<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 col-lg-4">
						<h4 class="mt-2 mb-4 pb-2 pt-2">Create FAQ</h4>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
			<div class="col-12 col-xl-8">
				<form @submit.prevent="onSubmit">
					<div class="lightgray-content p-3 rounded mb-4">
						<div class="form-group input-content">
							<label>Title</label>
							<input type="text" v-model="faq_data.title" class="form-control" v-validate="'required'" 
									name="title">
							<span class="input-error-msg">{{ errors.first('title') }}</span>
						</div>
						<div class="form-group input-content">
							<label>Order</label>
							<input type="text" v-model="faq_data.order" class="form-control" v-validate="'required|numeric'" 
									name="order">
							<span class="input-error-msg">{{ errors.first('order') }}</span>
						</div>
						<div class="form-group input-content">
							<label>Text</label>
							<wysiwyg v-model="faq_data.text" />
						</div>
					</div>
					<div class="text-right">
						<button type="submit" class="button large-button">Submit</button>
					</div>
				</form>
			</div><!--col-->
		</div><!--row-->
	</div>
</template>


<script>
export default {
	data : function(){
		return {
			faq_data : {
				title : '',
				text : '',
				order : 0
			}
		}
	},
	methods : {
		onSubmit : function(){
			this.$validator.validateAll().then((result) => {

				if(result){
					this.$store.dispatch('createFAQ', this.faq_data).then((res) => {

						this.$router.push({ name : 'admin.faq.index' });
					}).catch((error) => {
						
					});
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/terms/AdminTermsCreateComponent.vue